export const OrbitMark = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <circle cx="32" cy="32" r="7" fill="currentColor" />
    <ellipse cx="32" cy="32" rx="24" ry="10" stroke="currentColor" strokeWidth="2.4" transform="rotate(-24 32 32)" opacity="0.85" />
    <circle cx="50" cy="20" r="3.4" fill="#FF8A2B" />
  </svg>
);
